var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.metricsIsEmpty)?_c('BestSellerProductsTable',{attrs:{"statistics":_vm.statistics.MC[_vm.$page.props.store.id],"category":_vm.initFilters.category},on:{"reloadStats":_vm.fetchData}}):_c('p',{staticClass:"text-center text-xl mt-4"},[_vm._v(_vm._s(_vm.__('statistics.impressions_empty_for_filters')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }